import React, { useEffect, useRef, useState } from "react"
import { IParams } from "../../../context/ListRecordProvider/types"
import { getRealTimeLocationStatus, getRealTimeTransactionLog, getReport } from "../../../services/reports"
import ActionArea from "../../../components/ActionArea"
import SmartSearch from "../../../components/UI/SmartSearch"
import SwitchInput from "../../../components/UI/SwitchInput"
import ReportParser from "../../../components/ReportParser"
import endpoints from "../../../utils/endpoints"
import List from "../../../components/List"
import { useLoading } from "../../../context/LoadingProvider/useLoading"
import numeral from "numeral"
import { numberToCurrency } from "../../../utils/objectUtils"
import { sendSystemLog } from "../../../context/AuthProvider/useAuth"
import {useListRecord} from "../../../context/ListRecordProvider/useListRecord";
import {Space, Tag} from "antd";

const REFRESH_TIME =  10 * 1000

export interface ILocationStatus {
  alias: string,
  ticket_prizes: number,
  ticket_receipt_gross: number,
  cash: number,
  game_info: string,
  location_name: string
}

function RealTimeLocationsStatus() {
  const loading = useLoading()
  const listRecord = useListRecord()
  const record = listRecord.getRecord('realtimelocationstatus')
  const [params, setParams] = useState<IParams>({
    id: null,
    name: '',
    type: '',
  })
  const [search, setSearch] = useState('')
  const [validSearch, setValidSearch] = useState(false)
  const [refresh, setRefresh] = useState({
    time: 5,
    autoRefresh: true
  })
  const ref = useRef<any | null>(null)
  const [report, setReport] = useState<ILocationStatus[]>([])
  const log = {
    log_type: 'visited',
    log_object: 'rt_location_status'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  useEffect(() => {
    if(refresh.autoRefresh) {
      ref.current = setInterval(refreshReport, REFRESH_TIME);
    }
    if(!refresh.autoRefresh) {
     if(ref.current) clearInterval(ref.current)
    }
    
    return () => {
      if(ref.current){
        clearInterval(ref.current)
      }
    }
  }, [refresh, params])

  const handleEnter = (event: KeyboardEvent) => {
    if (loading.loading) return;
    if (!event.repeat && event.key === 'Enter') {
      refreshReport(true)
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEnter)
    return () => document.removeEventListener("keydown", handleEnter)
  })

  const refreshReport = async (enableLoading?: boolean) => {
	if(validSearch) {
	    if(enableLoading) loading.addLoading()
	    const res =  await getRealTimeLocationStatus({locationId: params.id })
	    setReport(res)
      listRecord.addRecord('realtimelocationstatus', params)
	    loading.removeLoading()
	}
  }

  const getTimestamp = (record: any) => {
    return record.timestampLastUpdate
  }

  return (
    <div className="report-view-page">
      <ActionArea disabled={!validSearch} buttonAction={() => refreshReport(true)} buttonText='Refresh'>
        <>
          <SmartSearch 
            label="Smart Search"
            searchBy={['location']} 
            onChange={(e: string) => setSearch(e)}
            value={search}
            status="active"
            onValidSearch={setValidSearch}
            onObjValueChange={(e: any) => setParams({...params, ...e})}
            autoFocus
          />
          <SwitchInput
            onChange={(e) => setRefresh({...refresh, autoRefresh: e})}
            value={refresh.autoRefresh}
            options={{check: true, uncheck: false,}}
            label="Auto Refresh"
          />
        </>
      </ActionArea>
      <div className="decks-management__colors">
        <Tag color="red">
          Not Connected
        </Tag>
        <Tag color="yellow">
          Not Connected to POS
        </Tag>
      </div>


      <List
        customClass = 'list-component-report'
        rows={report} 
        rowClassName={(record, index) => {
          // @ts-ignore
          if(((record.deviceType === 'GAME' && (record.durationSinceLastUpdate > 600 || record.durationSinceLastUpdate === -1)) || (record.deviceType === 'POS' && (record.durationSinceLastUpdate > 600 || record.durationSinceLastUpdate === -1)))|| !record.status === 'AVAILABLE' || record.timestampLastUpdate === '') return 'list-component-report__row-red' //10 mins
          // @ts-ignore
          if(record.isPOSWithAllDevicesOffline) return 'list-component-report__row-yellow';
          // @ts-ignore
          if(record.isGTWithNoPOSConnection) return 'list-component-report__row-yellow';
                    
          return ''
        }}
        columns={[
          {
            title: 'Location',
            dataIndex: 'location_name',
            key: 'location_name',
            render: (value: string) => value,
          },
          {
            title: 'Device',
            dataIndex: 'alias',
            key: 'alias',
            render: (value: string) => value,
          },
          {
            title: 'Type',
            dataIndex: 'deviceType',
            key: 'deviceType',
            render: (value: string) => value,
          },
          {
            title: 'Gross Revenue',
            dataIndex: 'ticket_receipt_gross',
            key: 'ticket_receipt_gross',
            render: (value: number) => numberToCurrency(value),
          },
          {
            title: 'Prizes Paid',
            dataIndex: 'ticket_prizes',
            key: 'ticket_prizes',
            render: (value: number) =>  numberToCurrency(value),
          },
          {
            title: 'Credits on Device',
            dataIndex: 'cash',
            key: 'cash',
            render: (value: number) => numberToCurrency(value),
          },
          {
            title: 'Game Being Played',
            dataIndex: 'game_info',
            key: 'game_info',
            render: (value: string) => value,
          },
          {
            title: 'Last Seen',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (value: string, record: any) => getTimestamp(record),
          },
        ]}
      />
    </div>
  )
}

export default RealTimeLocationsStatus